import { isSeriesRef, isSummaryRef } from "./watchRef.js";
/** @internal The `subId` key for a curve `id` + `field`. */
export const makeSubId = (id, field) => `${id}|${field}`;
/** @internal The key one summary is stored and matched under: the id, plus the operator and second id of a spread. */
export const summaryKey = (id, spread) => spread ? `${id}|${spread.op}|${spread.id}` : id;
/** @internal The `subId` a ref of any kind resolves to. Kinds never collide: series and summary ids carry a prefix. */
export const subIdFor = (ref) => {
    if (isSummaryRef(ref))
        return `summary:${summaryKey(ref.id, ref.spread)}`;
    if (isSeriesRef(ref))
        return `series:${makeSubId(ref.id, ref.field)}`;
    return makeSubId(ref.id, ref.field);
};
//# sourceMappingURL=internal.js.map